<template>
  <form-item v-bind="$attrs" v-on="$listeners" :class-name="className">
    <remote-select :class-name="className" :remove-set="removeSet" v-model="model[$attrs.prop]"
                   class="fullwidth" :disabled="$attrs.disabled"
                   :placeholder="$attrs.disabled ? '' : placeholder"
                   :using-code="usingCode">
    </remote-select>
  </form-item>
</template>

<script>
  import FormItem from '@/components/form/FormItem'
  import RemoteSelect from '@/components/selector/RemoteSelect'

  export default {
    name: 'RemoteFormItem',
    components: {
      RemoteSelect,
      FormItem
    },
    props: {
      className: String,
      removeSet: Set,
      placeholder: {
        type: String,
        default: '请选择'
      },
      usingCode: Boolean
    },
    computed: {
      model () {
        let parent = this.$parent
        while (parent) {
          if (parent.model != null) return parent.model
          parent = parent.$parent
        }
        return null
      }
    }
  }
</script>
